import { createFileRoute } from "@tanstack/react-router";
import { NavigationMenuExamples } from "@/utils/design-system/examples-exports";

export const Route = createFileRoute(
  "/demo/design-system/interactive/navigation-menu",
)({
  component: NavigationMenuExamples,
});
